<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file upsell--card-row.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  upsell--card-row.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: upsell--card-row
 Created by keni.
 with: IntelliJ IDEA
 Date: 29/05/2018
 Time: 10:29
------------------------------------------------------------------------------->
<template>
    <div v-if="records">
        <!--show the title if more than one event-->
        <div v-if="records" class="row">
            <div class="col-12">
                <h3 class="card-title">
                    <bold-words :word="{
                        text:(records.length == 1)?'most popular event':'popular events'
                        }"
                    />
                </h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12"
                 :class="{
                    'col-12 col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2':records.length == 2,
                    'col-md-4 offset-md-4':records.length == 1,
                    'col-12':records.length > 2,
                }"
            >
                <div class="row">
                    <div v-for="(record,index) in records"
                         class="col-12"
                         :class="{
                    'col-md-6 col-lg-4 col-xl-3 remaining_0':
                        // is the length the same as the limit
                        records.length % upsell_limit === 0
                    ,
                    'col-md-12 remaining_1':
                        // does the result leave 1 e.g. len=4 % limit=3 = 1 remaining
                        records.length % upsell_limit === 1
                   ,
                    'col-md-6 remaining_2':
                        // does the result leave 2 e.g. len=5 % limit=3 = 2 remaining
                        records.length % upsell_limit === 2
                        ,
                        'col-md-4 remaining_0':
                        // does the result leave 2 e.g. len=5 % limit=3 = 2 remaining
                        records.length % upsell_limit > 2

                }"
                    >
                        <tileCard
                                :record="record"
                                :records="records"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {_} from 'underscore';

    window.Vue.component('tileCard', require('./tileCard'));
    export default {
        name: "upsell--card-row",
        components: {},
        props: {
            upsell_request_data_url: String,
            upsell_type: String,
            category_id: String,
            upsell_limit: {
                type: Number,
                default: 3
            },
            laravel_route_uri: String,
            upsell_route_name: String,
            init_records: {
                type: Array,
                default: null
            }
        },
        created() {
            if (this.init_records.length > 0) {
                // this.records = this.init_records.slice(0, 1);
                this.records = this.init_records.slice(0, this.upsell_limit);
            }
        },
        destroyed() {
        },
        async mounted() {
            if (this.init_records.length <= 0) {
                this.readDataSet();
            }
        },
        data() {
            return {
                selectedColors: [],
                bgColors: [],
                /**
                 *
                 * @var records[].event_data.teams
                 * @var records[].event_data
                 * @var records[]
                 */
                records: null
            }
        },
        methods: {
            initBgColors() {
                let self = this;
                $('#css-build-colors div').each(function () {
                    // console.log($(this));
                    // let text = $(this).text();
                    // console.log('text',text);
                    self.bgColors.push($(this).text());
                });
                // console.log('this.bgColors',this.bgColors);
            },
            chooseBgColor() {
                let color = _.sample(this.bgColors);
                return color;

            },
            log(...arg) {
                console.log(...arg);
            },
            readDataSet() {
                // console.log('readDataSet', 'request');
                let self = this;
                let data = {
                    category_id: parseInt(this.category_id),
                    type: this.upsell_type,
                    limit: parseInt(this.upsell_limit)
                };

                axios.post(this.upsell_request_data_url, data)
                    .then(function (response) {
                        if (response.data.success) {
                            // console.log('response', 'response',response);
                            self.records = response.data.records;
                        }
                    })
                    .catch(function () {

                    });
            }
        },
        watch: {},
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/upsellCardRow.vue